import { render, staticRenderFns } from "./VariantSifterAssociationsDrawer.vue?vue&type=template&id=3a372a3b&scoped=true&"
import script from "./VariantSifterAssociationsDrawer.vue?vue&type=script&lang=js&"
export * from "./VariantSifterAssociationsDrawer.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterAssociationsDrawer.vue?vue&type=style&index=0&id=3a372a3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a372a3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a372a3b')) {
      api.createRecord('3a372a3b', component.options)
    } else {
      api.reload('3a372a3b', component.options)
    }
    module.hot.accept("./VariantSifterAssociationsDrawer.vue?vue&type=template&id=3a372a3b&scoped=true&", function () {
      api.rerender('3a372a3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterAssociationsDrawer.vue"
export default component.exports